var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogoNoText(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 192,
    height: 196,
    viewBox: "0 0 192 196",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4416_3585)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M177.293 99.4647C204.607 110.127 187.556 130.313 163.286 127.693C147.87 126.428 141.309 134.346 146.346 148.212C155.687 168.974 134.224 195.321 116.289 173.18C105.856 160.639 94.4872 163 86.0644 179.897C71.7305 209.659 46.9771 193.828 52.8848 167.519C55.7677 150.958 47.8686 144.401 32.4382 150.517C8.39588 161.766 -13.1366 139.095 12.7097 118.819C27.3695 107.029 27.0402 94.8824 12.165 86.2395C-14.0071 71.5162 6.81956 44.28 29.8688 50.6773C44.8911 53.6125 51.4503 45.6698 46.8089 30.1588C38.6909 5.64433 56.3737 -13.677 73.193 12.5212C82.9994 27.3338 93.1754 27.6681 99.7644 13.8969C110.912 -10.3462 133.611 11.3187 130.333 32.8717C128.903 47.0017 136.804 53.5863 150.779 49.8739C172.217 43.3506 195.779 60.2164 173.123 74.9992C160.321 83.6369 161.845 93.1129 177.345 99.4576L177.295 99.4629L177.293 99.4647Z",
    fill: "#F8BF3C"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4416_3585"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 191.277,
    height: 196,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoNoText);
export default __webpack_public_path__ + "static/media/logoNoText.be49e6f3311d4edd4a0357c66fe9cf6a.svg";
export { ForwardRef as ReactComponent };